import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * El nombre de un producto en una tabla (mapa de diseño 226, §3): el nombre en
 * su mayúscula original y, debajo, el código y la marca o tienda en gris.
 * `children` va debajo de todo (una etiqueta como «Ya no aplica»).
 */
export function CeldaProducto({
  nombre,
  detalle,
  children,
  className,
}: {
  nombre: ReactNode;
  detalle?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('min-w-0', className)}>
      {/* Ola final R1: un nombre o código de 150 letras sin espacios corta en
          su celda en vez de ensanchar la columna (medido en el navegador). */}
      <div className="min-w-0 font-medium [overflow-wrap:anywhere]">{nombre}</div>
      {detalle != null && detalle !== '' && (
        <div className="min-w-0 text-xs text-muted-foreground [overflow-wrap:anywhere]">
          {detalle}
        </div>
      )}
      {children}
    </div>
  );
}
